import { TableInstance } from 'react-table';
import React, { ReactElement } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { InstanceDeColonne } from './TypesTableSimple';

// eslint-disable-next-line @typescript-eslint/ban-types
export default function FiltreActif<T extends Object>({ table }: { table: TableInstance<T> }): ReactElement {
    const { columns } = table;
    const colonneActif = columns.find((col) => col.id === 'actif') as unknown as InstanceDeColonne<T>;
    return (
        <>
            <ButtonGroup>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    active={colonneActif.filterValue}
                    onClick={() => colonneActif.setFilter(true)}
                >
                    Actif
                </Button>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    active={!colonneActif.filterValue}
                    onClick={() => colonneActif.setFilter(false)}
                >
                    Inactif
                </Button>
            </ButtonGroup>
        </>
    );
}
